// extracted by css-extract-rspack-plugin
export default {"base":"u8eKDTphl0gOhOj8","tooltip":"xCAFKJ_ndsgBmW6Q","slide":"ZGhbvL3ok0iz4o8x"};